import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

/* eslint-disable react/prefer-es6-class */
// TODO: Move to a class

export default createReactClass({
  displayName: "RemoteButtonComponent",

  propTypes: {
    onSuccess: PropTypes.func,
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    children: PropTypes.node,
    tooltipText: PropTypes.string,
    url: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    confirmText: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
  },

  getInitialState() {
    return { loading: false };
  },

  componentDidMount() {
    // FYI, These are @rails/ujs event handlers
    this.buttonNode.addEventListener("ajax:beforeSend", this._onAjaxBeforeSend);
    this.buttonNode.addEventListener("ajax:success", this._onAjaxSuccess);
    this.buttonNode.addEventListener("ajax:error", this._onAjaxError);
  },

  componentWillUnmount() {
    this.buttonNode.addEventListener("ajax:beforeSend", this._onAjaxBeforeSend);
    this.buttonNode.addEventListener("ajax:success", this._onAjaxSuccess);
    this.buttonNode.addEventListener("ajax:error", this._onAjaxError);
  },

  _onAjaxBeforeSend() {
    return this.setState({ loading: true });
  },

  _onAjaxSuccess(event) {
    // https://guides.rubyonrails.org/working_with_javascript_in_rails.html#rails-ujs-event-handlers
    const data = event.detail[0];

    this.setState({ loading: false });
    if (this.props.onSuccess) {
      return this.props.onSuccess(event, data);
    }
  },

  _onAjaxError(event) {
    // https://guides.rubyonrails.org/working_with_javascript_in_rails.html#rails-ujs-event-handlers
    const xhr = event.detail[2];

    this.setState({ loading: false });
    if (xhr.responseJSON != null) {
      return alert(xhr.responseJSON['message']);
    }
  },

  render() {
    const contents = (
      this.state.loading
        ? <span><i className="fa fa-spinner fa-spin" /> {this.props.loadingText}</span>
        : this.props.children
    );

    const attributes = {};

    if (this.props.tooltipText) {
      attributes["aria-label"] = this.props.tooltipText;
    }

    return (
      <a
        ref={(buttonNode) => this.buttonNode = buttonNode}
        href={this.props.url}
        data-method={this.props.method}
        data-remote="true"
        data-confirm={this.props.confirmText}
        disabled={this.state.loading || this.props.loading}
        style={this.props.style}
        rel="nofollow"
        className={this.props.className}
        {...attributes}
      >
        {contents}
      </a>
    );
  }
});
